import { Injectable } from '@angular/core';

@Injectable()
export class ErrorHandlerService {
  public errorMessage: string;
  constructor() { }

  checkErrors(mines:number,height:number,length:number){
    if(height>70 || length>70){
      this.errorMessage = 'Height and Length must be less than 70';
      return true;
    }
    if(height<=0 || mines<=0 || length<=0){
      this.errorMessage = 'Please enter a valid number more than zero in all fields';
      return true;
    }
    if(height*length < mines){
      this.errorMessage = 'Please choose a bigger box or less mines';
      return true;
    }
    return false;
  }

  getErrorMessage(){
    return this.errorMessage;
  }

}



// WEBPACK FOOTER //
// ./src/app/minesweeper/services/error-handler.service.ts